
import OperationsBudgeting from '../views/operations/OperationsBudgeting.vue'
import OperationsSafaris from '../views/operations/OperationsSafaris.vue'
import OperationsAllocations from '../views/operations/OperationsAllocations.vue'
import OperationsRequisition from '../views/operations/OperationsRequisition.vue'
import OperationsPayments from '../views/operations/OperationsPayments.vue'

import TourSchedule from '../views/reservations/TourSchedule.vue'
import TourItinerary from '../views/reservations/TourItinerary.vue'
import TourCosting from '../views/reservations/TourCosting.vue'
import BookingForm from '../views/reservations/BookingForm.vue'
import TourSummary from '../views/reservations/TourSummary.vue'

import FinanceInvoice from '../views/finance/FinanceInvoice.vue'
import FinanceQuotes from '../views/finance/FinanceQuotes.vue'
import FinancePayments from '../views/finance/FinancePayments.vue'

import TourPermits from '../views/permits/TourPermits.vue'
import HeldPermits from '../views/permits/HeldPermits.vue'
import BookedPermits from '../views/permits/BookedPermits.vue'


export default [
    {
        path: '/operations/schedule',
        name: 'TourScheduleOps',
        component: TourSchedule
    },
    {
        path: '/operations/itinerary',
        name: 'TourItineraryOps',
        component: TourItinerary
    },
    {
        path: '/operations/booking',
        name: 'BookingFormOps',
        component: BookingForm
    },
    {
        path: '/operations/budgeting',
        name: 'OperationsBudgeting',
        component: OperationsBudgeting
    },
    {
        path: '/operations/safaris',
        name: 'OperationsSafaris',
        component: OperationsSafaris
    },
    {
        path: '/operations/allocations',
        name: 'OperationsAllocations',
        component: OperationsAllocations
    },
    {
        path: '/operations/requisitions',
        name: 'OperationsRequisition',
        component: OperationsRequisition
    },
    {
        path: '/operations/invoice',
        name: 'TourInvoiceOps',
        component: FinanceInvoice
    },
    {
        path: '/operations/quotes',
        name: 'FinanceQuotesOps',
        component: FinanceQuotes
    },
    {
        path: '/operations/permits',
        name: 'TourPermitOps',
        component: TourPermits
    },
    {
        path: '/operations/payments',
        name: 'OperationsPayments',
        component: OperationsPayments
    },
];